import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import API, {
  serviceApiUrl as ServiceQK,
  serviceTagsApiUrl as ServiceTagsQK,
  serviceCategoryApiUrl as CategoryQK
} from './api';
import { ResponseType } from 'src/constants/data';
import { ServiceBlockFilter, ServiceFilter } from 'src/types';

export const useGetInfiniteServiceBlocks = (params: Partial<ServiceFilter>) => {
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: [ServiceQK, ResponseType.List, JSON.stringify(params)],
    queryFn: ({ pageParam = 1 }) => API.getServicesBlocks(params, pageParam),
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil(lastPage.totalBlockCount / (params.limit ?? 10));
      const currentPage = allPages.length;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    placeholderData: keepPreviousData
  });
};

export const useGetCategory = (params: { name: string; slug?: string }) => {
  return useQuery({
    queryKey: [CategoryQK, ResponseType.Single, params],
    queryFn: () => API.getCategoryByName(params),
    placeholderData: keepPreviousData
  });
};

export const useGetTags = (params: Partial<ServiceBlockFilter>) => {
  return useQuery({
    queryKey: [ServiceTagsQK, ResponseType.List, params],
    queryFn: () => API.getTags(params),
    placeholderData: keepPreviousData
  });
};

export const useGetCategoriesTags = () => {
  return useQuery({
    queryKey: [ServiceTagsQK, ResponseType.List],
    queryFn: () => API.getCategoryTags(),
    placeholderData: keepPreviousData
  });
};

export const useGetServiceCategories = () => {
  return useQuery({
    queryKey: [CategoryQK, ResponseType.List],
    queryFn: () => API.getCategories(),
    placeholderData: keepPreviousData
  });
};
